import { Select } from "@msuite/ui/form";
import { ScopeTag } from "@msuite/ui/tag";
import type { OrderTemplateFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function OrderTemplateFormTableMenu() {
	const methods = useFormContext<OrderTemplateFormSchema>();

	/** Render */
	return (
		<div className="min-w-40 max-w-50">
			<Select
				control={methods.control}
				name="scope"
				isRequired={false}
				label={undefined}
				isNullable={false}
				options={(["global", "user"] as const).map((scope) => ({
					label: scope,
					value: scope,
					item: { scope },
				}))}
				renderOption={(item) => {
					return <ScopeTag scope={item.scope} />;
				}}
			/>
		</div>
	);
}
